'use strict';

module.exports = require('spectra-data');



// WEBPACK FOOTER //
// ./index.js